module.exports = __webpack_public_path__ + "static/ch-6-doodle-x@2x-09d801cd62ca4a1fe3ffcb98b70dce59.png";